import React from 'react';
import { Search, User } from 'lucide-react';

export default function Topbar() {
  return (
    <header className="flex items-center justify-between px-4 md:px-4 py-2 bg-white border-b border-gray-200 sticky top-0 z-10 shrink-0 h-[60px]">
      <div className="flex items-center gap-2 md:gap-4 shrink-0">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center text-white font-bold shrink-0">K</div>
          <span className="hidden sm:inline text-xl font-bold text-gray-800 tracking-tight">Katabo</span>
        </div>
      </div>
      
      <div className="flex-1 max-w-2xl px-4 sm:px-6 md:px-8">
        <div className="relative">
          <Search className="w-4 h-4 md:w-5 md:h-5 absolute left-3 top-2.5 text-gray-500" />
          <input 
            type="text" 
            placeholder="Search plans" 
            className="w-full bg-gray-100 rounded-lg pl-9 md:pl-10 pr-4 py-2 focus:bg-white focus:ring-1 focus:ring-blue-500 focus:outline-none text-sm md:text-base"
          />
        </div>
      </div>

      <div className="flex items-center shrink-0">
        <button className="p-1 md:p-2 hover:bg-gray-100 rounded-full active:scale-95 transition-transform">
          <User className="w-5 h-5 md:w-6 md:h-6 text-gray-600" />
        </button>
      </div>
    </header>
  );
}
